<template>
  <div
    v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_apartment')"
    style="border: 0px solid black; width:100%;"
  >
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <!-- Search container -->
        <!-- <div class="box box-success">
          <div class="box-header with-border">
            <h3 class="box-title">{{ $t("search.title") }}</h3>
          </div>
          <div class="box-body">
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-sm-3 col-md-3 col-lg-3">
                <input
                  type="text"
                  class="form-control"
                  :placeholder="$t('search.title')"
                  v-model="search.searchText"
                />
              </div>
              <div class="col-sm-3 col-md-3 col-lg-3">
                <button
                  type="button"
                  class="btn btn-labeled btn-success"
                  @click="onSearchCase"
                >
                  <span class="btn-label">
                    <i class="glyphicon glyphicon-search"></i>
                  </span>
                  {{ $t("search.search_button") }}
                </button>
              </div>
            </div>
          </div>
        </div> -->
        <!--  -->
        <div class="box box-primary">
          <div class="box-header with-border">
            <div
              style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
            >
              <b>{{ $t("apartmentType.title") }}</b>
              <!-- <lte-button
                style="float:right"
                type="btn btn-primary"
                right_icon="fa fa-plus"
                v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('create_apartment')"
                @click="addNew($event)"
                >{{ $t("common.addnew") }}</lte-button
              > -->
            </div>
          </div>
          <div class="box-body">
            <!-- B-Table Start -->
            <b-table
              :items="gridDataList"
              :fields="gridColumns"
              class="mt-3"
              outlined
              responsive
            >
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template #cell(actions)="row">
                <div class="btn-group">
                  <button
                    v-if="
                      GET_ACCOUNT_DATA.id == 1 || has_perm('update_apartment')
                    "
                    class="btn btn-primary btn-sm"
                    style="margin-left: 6px;"
                    @click="onOpenEditInput(row.item)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>
                  </button>
                </div>
              </template>
            </b-table>
            <!-- B-Table End -->
          </div>
        </div>
        <!--  -->
        <div class="box-footer clearfix" style="display:contents;">
          <paginator
            :totalItem="paginateData.totalItem"
            :currentPage="paginateData.currentPage"
            :pageSize="paginateData.pageSize"
            :totalPage="paginateData.totalPage"
            @onpaginate="onPagination"
          />
        </div>
        <lte-core-alert
          v-for="snackbar in GET_SNACK_BAR"
          :key="snackbar.id"
          :item="snackbar"
        ></lte-core-alert>
        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          color="#1E90FF"
        ></loading>
        <!--  -->
      </row>
    </div>
    <!--  -->
  </div>
</template>
<script>
import Paginator from "@/components/CustomPaginator.vue";
import { mapGetters, mapActions } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import utils from "@/lib/utils";
// import moment from "moment";
import Loading from "vue-loading-overlay";

export default {
  name: "CaseList",
  data() {
    return {
      gridDataList: [],
      gridColumns: [
        {
          label: "common.nonumber",
          key: "nonumber",
          class: "text-center "
        },
        {
          label: "apartmentType.apartmentTypeName",
          key: "apartmentTypeName",
          class: "text-center "
        },
        {
          label: "apartmentType.apartmentTypeCode",
          key: "apartmentTypeCode",
          class: "text-center "
        },
        // {
        //   label: "apartmentType.adults",
        //   key: "adults",
        //   class: "text-center "
        // },
        // {
        //   label: "apartmentType.children",
        //   key: "children",
        //   class: "text-center "
        // },
        {
          label: "apartmentType.description",
          key: "description",
          class: "text-center "
        },
        { key: "actions", label: "common.action" }
      ],
      originalRecordData: [],
      isModalVisible: false,
      search: {
        searchText: ""
      },
      isLoading: false,
      paginateData: {
        totalItem: 1,
        currentPage: 1,
        pageSize: 1,
        totalPage: 1
      },
      apartmentTypeData: {
        id: 0,
        apartmentTypeName: null,
        apartmentTypeCode: null,
        description: null,
        adults: 0,
        children: 0,
        bedrooms: 0,
        bathroom: 0
      }
    };
  },
  watch: {
    GET_LANG: function() {
      this.getApartmentTypeList(1);
    },
    GET_APARTMENT_TYPE_LIST_DATA: function() {
      let paginate = this.GET_APARTMENT_TYPE_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.gridDataList = [];
      let data = this.GET_APARTMENT_TYPE_LIST_DATA.results;
      data.forEach((element, i) => {
        let id = element.id;
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;

        let data = {
          id: id,
          nonumber: nonumber,
          apartmentTypeName: element.name,
          apartmentTypeCode: element.code,
          description: element.description,
          adults: element.adults,
          children: element.children,
          bedrooms: element.bedrooms,
          bathroom: element.bathroom
        };
        this.gridDataList.push(data);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_APARTMENT_TYPE_LIST_DATA",
      "GET_LANG"
    ])
  },

  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    getSearchData: function(data) {
      this.search.searchText = data;
      this.getApartmentTypeList(1);
    },
    onSearchCase: function() {
      this.getApartmentTypeList(1);
    },
    onOpenEditInput: function(row) {
      this.$router.push({
        name: "ApartmentTypePriceList",
        params: {
          apartmentTypeId: row.id
        }
      });
    },
    onPagination: function(data) {
      this.getApartmentTypeList(data);
    },
    getApartmentTypeList: function(page) {
      this.isLoading = true;
      let filter = {
        params: {
          page: page,
          searchText: this.search.searchText
        }
      };
      this.GET_APARTMENT_TYPE_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_APARTMENT_TYPE_LIST"
    ])
  },
  mounted() {
    this.getApartmentTypeList(1);
  },

  components: {
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    loading: Loading
  }
};
</script>
<style scoped>
label.required:after {
  content: " *";
  color: red;
  position: absolute;
  padding-left: 8px;
  top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Configuration/ApartmentType/ApartmentType.vue